<template>
  <el-dialog
    :title="'设置' + model.name + '销售目标（单位：万元）'"
    :visible.sync="visible"
    width="50%"
    @close="$emit('update:show', false)"
  >
    <el-form
      v-if="model.goals"
      ref="form"
      label-width="90px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="年度目标">
        <el-input
          v-model="model.goals[0]"
          size="medium"
          placeholder="年度目标"
        ></el-input>
      </el-form-item>
      <div class="monthes">
        <el-form-item
          size="small"
          v-for="(month, index) in monthes"
          :label="month"
          :key="index"
        >
          <el-input
            v-model="model.goals[index + 1]"
            :placeholder="month + '销售目标'"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submiting" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  updateCustomer,
  userList,
  saleGoalDetail,
  saleGoalSet,
} from '../service/getData'

export default {
  props: {
    model: {
      type: Object,
      default: {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
    model() {},
  },
  data() {
    return {
      monthes: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],
      visible: this.show,
      formRules: {
        user_id: [
          { required: true, message: '请选择变更目标', trigger: 'change' },
        ],
      },
      submiting: false,
      users: [],
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let goals = this.model.goals.map((item) => {
            return parseInt(item) || 0
          })
          this.model.goals = goals.join(',')
          let res = await saleGoalSet(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }

          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.monthes {
  display: flex;
  flex-wrap: wrap;
}

.monthes .el-form-item {
  width: 33%;
}
</style>